<template>
  <Teleport to="body">
    <div class="module-error-container">
      <div class="content-wrapper">
        <!-- Анимированная иллюстрация ошибки -->
      <div class="illustration">
        <div class="error-icon">
          <svg viewBox="0 0 200 200" class="broken-module">
            <!-- Разбитый модуль -->
            <rect x="40" y="60" width="120" height="80" rx="8" class="module-piece module-piece-1" />
            <rect x="40" y="60" width="120" height="80" rx="8" class="module-piece module-piece-2" />
            <line x1="50" y1="70" x2="150" y2="130" class="crack-line" />
            <line x1="150" y1="70" x2="50" y2="130" class="crack-line" />
            <!-- Восклицательный знак -->
            <circle cx="100" cy="100" r="25" class="warning-circle" />
            <line x1="100" y1="90" x2="100" y2="105" class="warning-mark" />
            <circle cx="100" cy="112" r="2" class="warning-dot" />
          </svg>
        </div>
        
        <!-- Плавающие элементы -->
        <div class="floating-elements">
          <div class="floating-dot" style="--delay: 0s; --x: -20px; --y: -30px;"></div>
          <div class="floating-dot" style="--delay: 0.5s; --x: 40px; --y: -20px;"></div>
          <div class="floating-dot" style="--delay: 1s; --x: -30px; --y: 20px;"></div>
        </div>
      </div>

      <!-- Текстовый контент -->
      <div class="text-content">
        <h1 class="title">Не удалось загрузить модуль</h1>
        <p class="description">
          Произошла ошибка при загрузке материалов модуля. Проверьте подключение к интернету и попробуйте снова.
        </p>
      </div>

      <!-- Действия -->
      <div class="actions">
        <button @click="retry" class="btn btn-primary">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <polyline points="23 4 23 10 17 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Повторить попытку
        </button>
        <button @click="goBack" class="btn btn-secondary">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="19" y1="12" x2="5" y2="12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="12 19 5 12 12 5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Вернуться назад
        </button>
      </div>

      <!-- Дополнительная информация -->
      <div class="help-section">
        <p class="help-title">Что можно сделать:</p>
        <ul class="help-list">
          <li>Проверьте подключение к интернету</li>
          <li>Обновите страницу (F5)</li>
          <li>Попробуйте зайти позже</li>
          <li>Обратитесь в поддержку, если проблема повторяется</li>
        </ul>
      </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ModuleLoadError',
  props: {
    onRetry: {
      type: Function,
      required: true
    }
  },
  methods: {
    retry() {
      console.log('[ModuleLoadError] retry clicked')
      this.onRetry()
    },
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1)
      } else {
        this.$router.push('/student-dashboard')
      }
    }
  }
}
</script>

<style scoped>
.module-error-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  padding: 2rem;
  overflow: hidden;
}

.module-error-container::before {
  content: '';
  position: absolute;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  animation: rotate 30s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.content-wrapper {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 600px;
  width: 100%;
}

/* Иллюстрация ошибки */
.illustration {
  position: relative;
  margin-bottom: 2rem;
}

.error-icon {
  display: inline-block;
  animation: shake 3s ease-in-out infinite;
}

@keyframes shake {
  0%, 100% { transform: translateX(0) rotate(0deg); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px) rotate(-2deg); }
  20%, 40%, 60%, 80% { transform: translateX(5px) rotate(2deg); }
}

.broken-module {
  width: 200px;
  height: 200px;
  filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.2));
}

.module-piece {
  fill: rgba(255, 255, 255, 0.9);
  stroke: white;
  stroke-width: 3;
}

.module-piece-1 {
  animation: piece-float-1 2s ease-in-out infinite;
}

.module-piece-2 {
  animation: piece-float-2 2s ease-in-out infinite;
  opacity: 0.7;
}

@keyframes piece-float-1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-3px, -3px); }
}

@keyframes piece-float-2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(3px, 3px); }
}

.crack-line {
  stroke: #0ea5e9;
  stroke-width: 2;
  stroke-linecap: round;
  opacity: 0.6;
}

.warning-circle {
  fill: #fbbf24;
  stroke: white;
  stroke-width: 3;
}

.warning-mark {
  stroke: white;
  stroke-width: 4;
  stroke-linecap: round;
}

.warning-dot {
  fill: white;
}

/* Плавающие элементы */
.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.floating-dot {
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  opacity: 0.5;
  animation: float 3s ease-in-out infinite;
  animation-delay: var(--delay);
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
    opacity: 0.5;
  }
  50% {
    transform: translate(var(--x), var(--y));
    opacity: 0.2;
  }
}

/* Текстовый контент */
.text-content {
  margin-bottom: 2rem;
}

.title {
  font-size: 2rem;
  font-weight: 700;
  color: #0c4a6e;
  margin: 0 0 1rem 0;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.description {
  font-size: 1.125rem;
  color: #0369a1;
  line-height: 1.6;
  margin: 0;
}

/* Кнопки действий */
.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.btn:active {
  transform: translateY(0);
}

.btn-primary {
  background: #0ea5e9;
  color: white;
}

.btn-primary:hover {
  background: #0284c7;
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.9);
  color: #0369a1;
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: white;
}

.icon {
  width: 20px;
  height: 20px;
}

/* Секция помощи */
.help-section {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.help-title {
  color: #0c4a6e;
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
}

.help-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  color: #0369a1;
  font-size: 0.9375rem;
}

.help-list li {
  padding: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
}

.help-list li::before {
  content: '•';
  position: absolute;
  left: 0.5rem;
  color: #0ea5e9;
  font-weight: bold;
}

/* Адаптивность */
@media (max-width: 768px) {
  .module-error-container {
    margin: 1rem;
    padding: 1.5rem;
  }

  .broken-module {
    width: 150px;
    height: 150px;
  }

  .title {
    font-size: 1.5rem;
  }

  .description {
    font-size: 1rem;
  }

  .actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .broken-module {
    width: 120px;
    height: 120px;
  }

  .help-section {
    padding: 1rem;
  }
}
</style>
